var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "12px",
    viewBox: "0 0 8 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UIKit",
    transform: "translate(-566.000000, -879.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(530.000000, 750.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron/Right",
    transform: "translate(40.000000, 135.000000) scale(-1, 1) translate(-40.000000, -135.000000) translate(28.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Chevron"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#8298AB",
    fillRule: "nonzero",
    points: "10 6 8.59 7.41 13.17 12 8.59 16.59 10 18 16 12"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.81b8f199.svg";
export { ForwardRef as ReactComponent };